import { defineMessages } from 'react-intl';

export const insuranceTermsCheckboxMessages = defineMessages({
  title: {
    id: 'b5L0A9',
    description: 'Title shown above the insurance terms acknowledgement in DE and GB',
    defaultMessage: 'Total Shipping Protection by Xcover',
  },
  acknowledgement: {
    id: 'BtkPkb',
    description: 'Insurance terms acknowledgement checkbox label shown during wallet registration in DE and GB',
    defaultMessage:
      'By adding protection you confirm you have read and agree to the {policyTerms} and {insuranceProductInformationDocument}. By selecting this insurance you confirm you have your company registered in {countryOfResidence} and you are over 18 years old.',
  },
  policyTerms: {
    id: '95u76S',
    description: 'Link text for the insurance policy terms document',
    defaultMessage: 'Policy Terms',
  },
  insuranceProductInformationDocument: {
    id: 'NT8udq',
    description: 'Link text for the insurance product information document',
    defaultMessage: 'Insurance Product Information Document',
  },
  countryOfResidenceGB: {
    id: 'S6EcD0',
    description: 'Country of company registration named in the GB insurance terms acknowledgement',
    defaultMessage: 'the United Kingdom',
  },
  countryOfResidenceDE: {
    id: 'SeRz4X',
    description: 'Country of company registration named in the DE insurance terms acknowledgement',
    defaultMessage: 'Germany',
  },
});
